import create from 'zustand';

interface AssignablesStoreState {
  clearReadingSelections: () => void;
  form: {
    getState: any,
    getValues: any,
    mutators: any,
  };
  formChangeValue: ((value: any, key: string) => {}) | (() => void);
  games: any,
  hasUnits: boolean;
  initialValues: {
    canEditMaxScore: boolean,
    gradingNotebookBy: string | null,
    maxScore: number | null,
    modelType: string | null,
    modelsToAssign: [{ label: string, value: string }] | [],
    randomizeAnswers: boolean | null,
    readingAssignableSelections: [string] | [],
    showAnswersToStudents: boolean | null,
    slideShowSelect: string | null,
  };
  isFetching: boolean;
  isMiddleSchoolProgram: boolean;
  isScience: boolean;
  // Type values the API flagged as libraries. Libraries are content data, so the set varies by program.
  libraryTypes: string[];
  loadingLessons: boolean;
  loadingTypes: boolean;
  programId: string;
  openAssessmentInNewTab: boolean;
  refetch: () => void;
  resetState: (arg) => void;
  score: number;
  selectedType: string;
  selectedUnitLesson: { [key: string]: string | number };
  setSelectedType: (newState: string) => void;
  setStore: (newState: object) => void;
  setUnitLesson: (selectedUnitLesson: { [key: string]: string | number }) => void;
  stafferId: number;
}

const useAssignablesStore = create<AssignablesStoreState>()((set, get) => ({
  clearReadingSelections: () => {
    const { form, formChangeValue } = get();
    const values = form.getState().values || {};

    Object.keys(values)
      .filter(key => key.startsWith('notebook-reading-'))
      .forEach(key => formChangeValue?.([], key));
  },
  form: {
    getState: () => ({}),
    getValues: () => {},
    mutators: () => {},
  },
  formChangeValue: null,
  games: [],
  hasUnits: false,
  initialValues: {
    canEditMaxScore: true,
    gradingNotebookBy: null,
    maxScore: null,
    modelType: null,
    modelsToAssign: [],
    randomizeAnswers: false,
    readingAssignableSelections: [],
    showAnswersToStudents: false,
    slideShowSelect: null,
  },
  isFetching: true,
  isMiddleSchoolProgram: false,
  isScience: false,
  libraryTypes: [],
  loadingLessons: true,
  loadingTypes: true,
  openAssessmentInNewTab: false,
  programId: '',
  score: 0,
  refetch: () => {},
  resetState: (overrides) => {
    set(state => ({ ...state,
      initialValues: {
        canEditMaxScore: true,
        gradingNotebookBy: null,
        maxScore: null,
        modelType: null,
        modelsToAssign: [],
        randomizeAnswers: false,
        readingAssignableSelections: [],
        showAnswersToStudents: false,
        slideShowSelect: null,
      },
      libraryTypes: [],
      loadingLessons: true,
      loadingTypes: true,
      selectedType: '',
      selectedUnitLesson: { label: '', value: '' },
      ...overrides,
    }));
  },
  selectedType: '',
  selectedUnitLesson: { label: '', value: '' },
  setSelectedType: newType => set(state => ({ ...state, selectedType: newType })),
  setUnitLesson: selectedUnitLesson => set(state => ({ ...state, selectedUnitLesson })),
  setStore: newState => set(state => ({ ...state, ...newState })),
  stafferId: 0,
}));

export default useAssignablesStore;
